import React from 'react'
import Icon from './FAIcon'
import Flex from './Flex'
import HighlightedText from './HighlightedText'
import meetringRoomImage from '../../assets/meetingRoom.png'
import { IUsageType, ISpaceType } from '@api'
import { meetingRoom, seatable } from './canvas/utils'
import { Classes } from '@blueprintjs/core'
import css from './spaceCard.module.scss'

interface ISpace {
  name: string
  externalId: string
  spaceType: ISpaceType
  usageType: IUsageType | null
}

interface SpaceCardProps {
  space: ISpace
  query?: string
}

export function SpaceCard(props: SpaceCardProps) {
  return (
    <Flex align="center">
      <div className={css.space_card_icon_wrapper}>
        <SpaceIcon {...props} />
      </div>
      <div>
        <SpaceLabel {...props} />
        <SpaceType {...props} />
      </div>
    </Flex>
  )
}

export function SpaceCardSkeleton() {
  return (
    <Flex align="center">
      <div className={css.space_card_icon_wrapper}>
        <div className={`${Classes.SKELETON} ${css.circle}`} style={{ width: 24, height: 24 }} />
      </div>
      <div>
        <div className={Classes.SKELETON} style={{ marginBottom: 2, width: 120 }}>
          placeholder
        </div>
        <div className={`${Classes.SKELETON} ${css.small}`} style={{ width: 80 }}>
          {' '}
          placeholder
        </div>
      </div>
    </Flex>
  )
}

export function SpaceIcon({ space }: SpaceCardProps) {
  if (seatable(space.spaceType)) {
    return <Icon name="chair-office" />
  }
  return (
    <div className={css.space_card_circle}>
      {meetingRoom(space.spaceType) ? (
        <img alt="meeting room icon" src={meetringRoomImage} style={{ width: 20, height: 20 }} />
      ) : (
        <div className={css.space_card_rect} />
      )}
    </div>
  )
}

function SpaceLabel({ space, query }: SpaceCardProps) {
  let label = space.externalId

  if (!seatable(space.spaceType) && space.name) {
    label = space.name
  }

  return <HighlightedText text={label} query={query} />
}

function SpaceType({ space, query }: SpaceCardProps) {
  if (seatable(space.spaceType) && space.usageType) {
    return (
      <div className={css.space_card_small}>
        <HighlightedText text={space.usageType.displayName} query={query} />
      </div>
    )
  }

  return (
    <div className={css.space_card_small}>
      <HighlightedText text={space.spaceType.displayName} query={query} /> (
      <HighlightedText text={space.externalId} query={query} />)
    </div>
  )
}
